export default __webpack_public_path__ + "static/media/arrow5.1d7e7a06.svg";